// extracted by mini-css-extract-plugin
export default {"choosetyperowcol2":"Updateliveproject_choosetyperowcol2__-kvre"};